import { AnimatePresence, motion } from "framer-motion";

export default function Modal({ isOpen, onClose, children, size = "medium" }) {
    const sizeClasses = {
        small: "max-w-xl",
        medium: "max-w-2xl",
        large: "max-w-4xl",
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <AnimatePresence>
                    {isOpen && (
                        <motion.div
                            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 sm:p-6"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={onClose}
                        >
                            <motion.div
                                className={`
          bg-white shadow-lg w-full relative
          p-4 sm:p-6
          rounded-2xl sm:rounded-2xl
          ${sizeClasses[size]}
          mx-4 sm:mx-6 md:mx-0
          max-h-[90vh]
          overflow-y-auto
        `}
                                initial={{ scale: 0.9, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0.9, opacity: 0 }}
                                transition={{ duration: 0.2 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <button
                                    onClick={onClose}
                                    className="absolute top-3 right-3 text-darkSurface hover:text-text-dark"
                                >
                                    ✕
                                </button>
                                {children}
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>

            )}
        </AnimatePresence>
    );
}
